import Physical from './Physical';

export default Physical;
